import { PreflightTaskState } from '../preflight-task-state.enum';

const PreflightTaskActiveStates = [PreflightTaskState.PENDING, PreflightTaskState.STARTED, PreflightTaskState.PROGRESS];

export const isPreflightTaskActive = (taskState: PreflightTaskState): boolean =>
  PreflightTaskActiveStates.indexOf(taskState) !== -1;
